import { Link } from 'react-router-dom';

/**
 * Slim "back to home" link shown at the top of every /my/* user page.
 *
 * Rendered centrally by PlatformLayout (gated on the /my/ path prefix) so it
 * appears uniformly on all user-area pages — including the page components
 * shared with the professional dashboard — without leaking into /dashboard/*.
 * Requested by Laura (21/07): every user session needs an obvious way back home.
 */
export function BackToHomeBar() {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 pt-4">
      <Link
        to="/"
        className="inline-flex items-center gap-1.5 rounded text-sm font-medium text-neutral-600 transition-colors hover:text-brand-teal"
      >
        <svg
          aria-hidden="true"
          className="h-4 w-4 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="m15 19-7-7 7-7" />
        </svg>
        Torna alla home
      </Link>
    </div>
  );
}
